import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Clock, Coins, Sparkles, ArrowLeft } from 'lucide-react'
import * as stylex from '@stylexjs/stylex'
import { styles } from '@/styles/ExamplesPage.stylex'
import { examples } from '../example-studio/examples'


export default function ExamplesPage() {
    const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

    return (
        <div {...stylex.props(styles.examplesPage)}>
            {/* Header Navigation */}
            <Link to="/" {...stylex.props(styles.backLink)}>
                <ArrowLeft size={20} />
                Back to Home
            </Link>

            {/* Page Header */}
            <div {...stylex.props(styles.pageHeader)}>
                <div {...stylex.props(styles.headerContent)}>
                    <h1 {...stylex.props(styles.pageTitle)}>
                        <Sparkles size={32} {...stylex.props(styles.titleIcon)} />
                        Explore Examples
                    </h1>
                    <p {...stylex.props(styles.pageSubtitle)}>
                        Discover what's possible with AiBrush Studio through real project examples.
                        See the creative potential, understand the costs, and get inspired for your next project.
                    </p>
                </div>
            </div>

            {/* Examples Grid */}
            <section {...stylex.props(styles.examplesSection)}>
                <div {...stylex.props(styles.examplesGrid)}>
                    {examples.map((example, index) => (
                        <div
                            key={index}
                            {...stylex.props(styles.exampleBox)}
                            onMouseEnter={() => setHoveredIndex(index)}
                            onMouseLeave={() => setHoveredIndex(null)}
                        >
                            <div {...stylex.props(styles.videoContainer)}>
                                <video
                                    src={example.videoSrc}
                                    poster={example.thumbnailSrc}
                                    controls
                                    loop
                                    preload="none"
                                    playsInline
                                    {...stylex.props(
                                        styles.videoElement,
                                        hoveredIndex === index && styles.videoElementHover
                                    )}
                                />
                                <div {...stylex.props(styles.categoryBadge)}>{example.type}</div>
                            </div>

                            <div {...stylex.props(styles.content)}>
                                <h3 {...stylex.props(styles.exampleTitle)}>{example.title}</h3>
                                <p {...stylex.props(styles.exampleDescription)}>{example.concept}</p>

                                <div {...stylex.props(styles.metadata)}>
                                    <div {...stylex.props(styles.metadataItem)}>
                                        <Coins size={16} {...stylex.props(styles.metadataIcon)} />
                                        <span {...stylex.props(styles.metadataText)}>{example.credits} credits</span>
                                    </div>
                                    <div {...stylex.props(styles.metadataItem)}>
                                        <Clock size={16} {...stylex.props(styles.metadataIcon)} />
                                        <span {...stylex.props(styles.metadataText)}>{example.creating_time}</span>
                                    </div>
                                </div>

                                <div {...stylex.props(styles.actions)}>
                                    <Link to={`/example-studio?id=${example.id}`}
                                        {...stylex.props(styles.viewButton)}>
                                        View Project
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Call to Action */}
            <section {...stylex.props(styles.ctaSection)}>
                <div {...stylex.props(styles.ctaContent)}>
                    <h2 {...stylex.props(styles.ctaTitle)}>Ready to Create Your Own?</h2>
                    <p {...stylex.props(styles.ctaDescription)}>
                        Start building amazing AI-powered content with AiBrush Studio.
                        Choose from our wide range of AI models and create professional-quality media in minutes.
                    </p>
                    <div {...stylex.props(styles.ctaButtons)}>
                        <a href="https://aibrush.co/projects" {...stylex.props(styles.primaryButton)} target="_blank" rel="noopener noreferrer">
                            Start Creating
                        </a>
                        <a href="/quick-start" {...stylex.props(styles.secondaryButton)}>
                            Learn How
                        </a>
                    </div>
                </div>
            </section>
        </div>
    )
}
